import z from "zod";

import {
  ThreadResponseStatus,
  PhoneNumberMessageClass,
  ThreadSortBy,
  CampaignStatus,
  ThreadInboxFilterType,
} from "~frontend/__generated__/graphql";
import { zodEnum } from "~frontend/util/zodHelpers";

export const ThreadFiltersAndSortSchema = z.object({
  campaignsAndTexters: z.array(
    z.object({
      type: z.enum(["campaign", "texter"]),
      id: z.string(),
      name: z.string().nullable(),
    })
  ),
  tags: z.array(
    z.object({
      id: z.string(),
      name: z.string().nullable(),
    })
  ),
  tagFilterOperation: z.enum(["all", "any"]),
  searchType: z.enum(["message", "contact"]),
  search: z.string(),
  isOptedOut: z.enum(["OPTED_OUT", "NOT_OPTED_OUT", "ANY"]),
  responseStatus: zodEnum<ThreadResponseStatus>(ThreadResponseStatus).or(
    z.enum([""])
  ),
  phoneNumberMessageClasses: z.array(
    zodEnum<PhoneNumberMessageClass>(PhoneNumberMessageClass)
  ),
  inboxes: z.array(
    z.object({
      id: z.string(),
      name: z.string().nullable(),
      type: z.enum(["general", "escalation"]).nullable(),
    })
  ),
  inboxFilterType: zodEnum<ThreadInboxFilterType>(ThreadInboxFilterType),
  campaignStatuses: z.array(zodEnum<CampaignStatus>(CampaignStatus)),
  sortBy: zodEnum<ThreadSortBy>(ThreadSortBy),
});

export type ThreadFilterAndSortValues = z.infer<
  typeof ThreadFiltersAndSortSchema
>;
